(function impressionTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  const previousImpressionTracker = global.NewHomeSource.Analytics.impressionTracker;
  const configurations = {
    hasBeenAttached: false,
    mutationObserverOptions: {
      childList: true,
      subtree: true,
    },
    intersectionObserverOptions: {
      threshold: 0.5
    },
  };

  /**
   * @private
   * Iterates through all descends of a DOM node and pushes them to the nodes list.
   *
   * @param {Node} node The DOM node to walk.
   */
  function walkNodeTree(node) {
    let elementsAdded = [];

    if (node.nodeType === 1 && node.dataset && node.dataset.impression) {
      elementsAdded.push(node);
    }

    const childNodesLength = node.childNodes.length;

    for (let index = 0; index < childNodesLength; index += 1) {
      const child = node.childNodes[index];
      const childElements = walkNodeTree(child);

      if (childElements.length > 0) {
        elementsAdded = [].concat(elementsAdded, childElements);
      }
    }

    return elementsAdded;
  }

  /**
   * @private
   * handleDomMutations: callback to be execute after an element has been added to the DOM.
   *
   * @param {Array} mutations a list of MutationRecord intstances.
   */
  function handleDomMutations(mutations) {
    if (!mutations) {
      return;
    }

    let elementsAdded = [];
    const mutationsLength = mutations.length;

    for (let index = 0; index < mutationsLength; index += 1) {
      const mutation = mutations[index];
      const totalElementsAdded = mutation.addedNodes ? mutation.addedNodes.length : 0;

      for (let elementIndex = 0; elementIndex < totalElementsAdded; elementIndex += 1) {
        const addedElement = mutation.addedNodes[elementIndex];
        const impressionNodes = walkNodeTree(addedElement);

        if (impressionNodes.length > 0) {
          elementsAdded = [].concat(elementsAdded, impressionNodes);
        }
      }
    }

    if (elementsAdded.length === 0) {
      return;
    }

    for (let currentElement = 0; currentElement < elementsAdded.length; currentElement += 1) {
      configurations.intersectionObserver.observe(
        elementsAdded[currentElement],
        configurations.intersectionObserverOptions
      );
    }
  }

  /**
 * @private
 * handleDomMutations: callback to be execute after an element has been added to the DOM.
 *
 * @param {Array} mutations a list of MutationRecord intstances.
 */
  function handleMutationsOnViewPort(mutations) {
    if (!mutations) {
      return;
    }

    const elements = [];
    let currentMutation;
    for (let index = 0; index < mutations.length; index += 1) {
      currentMutation = mutations[index];
      if (currentMutation.isIntersecting) {
        elements.push(currentMutation.target);
        if (currentMutation.target.dataset.noUnobserve !== 'true') {
          configurations.intersectionObserver.unobserve(currentMutation.target);
        }
      }
    }
    if (elements.length > 0) {
      let trackertElements = [];
      for (let index = 0; index < configurations.totalHandlers; index += 1) {
        const handler = configurations.handlers[index];
        const selector = configurations.handlers[index].impressionTrackerSelector();
        for (let count = 0; count < elements.length; count += 1) {
          const element = elements[count];
          if (typeof selector === 'string' && element.getAttribute(selector) !== null) {
            trackertElements.push(element);
          }
        }
        if (trackertElements.length > 0) {
          configurations.queue.pushTask(handler.impressionTracker.bind(trackertElements));
        }
        trackertElements = [];
      }
    }
  }

  /**
 * @private
 * handleMutationsAsync: callback to be execute after an element has been added to the DOM async.
 *
 * @param {Array} mutations a list of MutationRecord intstances.
 */
  function handleMutationsAsync(mutations) {
    setTimeout(() => handleDomMutations(mutations), 0);
  }

  /**
   * @constructs NewHomeSource.Analytics.impressionTracker
   *
   * @param {IdleQueue} eventsQueue that runs the tasks on idle periods.
   * @param {Array} handlers that will react to the impression tracking.
   */
  function ImpressionTracker(eventsQueue, handlers) {
    if (!global.MutationObserver) {
      return;
    }

    configurations.queue = eventsQueue;
    configurations.handlers = [];

    const totalHandlers = handlers.length;

    for (let index = 0; index < totalHandlers; index += 1) {
      if (handlers[index] &&
        typeof handlers[index].impressionTracker === 'function' &&
        typeof handlers[index].impressionTrackerSelector === 'function') {
        configurations.handlers.push(handlers[index]);
      }
    }

    configurations.totalHandlers = configurations.handlers.length;
  }

  /**
   * @public
   * init: creates a new MutationObserver to observe changes in the body of the document.
   */
  ImpressionTracker.init = function init() {
    if (configurations.hasBeenAttached) {
      return;
    }

    configurations.hasBeenAttached = true;
    configurations.mutationObserver = new global.MutationObserver(handleMutationsAsync);
    configurations.intersectionObserver = new global.IntersectionObserver(handleMutationsOnViewPort);
    configurations.mutationObserver.observe(global.document.body, configurations.mutationObserverOptions);

    for (let index = 0; index < configurations.totalHandlers; index += 1) {
      const handler = configurations.handlers[index];
      const elements = document.querySelectorAll('[' + handler.impressionTrackerSelector() + ']');
      for (let currentElement = 0; currentElement < elements.length; currentElement += 1) {
        configurations.intersectionObserver.observe(
          elements[currentElement],
          configurations.intersectionObserverOptions
        );
      }
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  ImpressionTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.impressionTracker = previousImpressionTracker;
    return ImpressionTracker;
  };

  global.NewHomeSource.Analytics.impressionTracker = ImpressionTracker;
}(window));
